import { LogoMark } from "./Logo";

const TH = ({ children, className = "" }) => <th className={`text-[9px] font-bold ${className}`}>{children}</th>;
const TD = ({ children, className = "" }) => <td className={`text-[10px] ${className}`}>{children}</td>;
const fmtDate = (iso) => new Date(iso + "T00:00:00").toLocaleDateString("id-ID", { weekday: "long", day: "2-digit", month: "long", year: "numeric" });
const fmtAt = (iso, withDate) => new Date(iso).toLocaleString("id-ID", { ...(withDate ? { day: "2-digit", month: "2-digit", year: "numeric" } : {}), hour: "2-digit", minute: "2-digit" });
const stamp = () => new Date().toLocaleString("id-ID", { day: "2-digit", month: "2-digit", year: "numeric", hour: "2-digit", minute: "2-digit" });

/** Arsip harian riwayat scan QC / delivery (A4) — `kind` = "qc" | "delivery" */
export function HistoryPrintView({ kind, rows, date, user }) {
  const isQc = kind === "qc";
  const title = isQc ? "ARSIP RIWAYAT SCAN QC" : "ARSIP RIWAYAT DELIVERY";
  const zh = isQc ? "质检扫描记录归档" : "发货记录归档";
  const ok = rows.filter((r) => r.result === "OK").length;
  const totalQty = rows.reduce((a, r) => a + (Number(r.qty) || 0), 0);
  const sorted = [...rows].sort((a, b) => (a.at < b.at ? -1 : 1));
  return (
    <div className="print-sheet" data-testid={`${kind}-history-print-sheet`}>
      <div className="grid grid-cols-3 items-start gap-3 border-b-2 border-black pb-3">
        <div className="flex items-center gap-2">
          <LogoMark size={46} />
          <div className="leading-tight">
            <div className="font-display text-[12px] font-bold">PT HONGLU BAJA INDONESIA</div>
            <div className="cn text-[9px]">宏睿钢印印尼有限公司</div>
          </div>
        </div>
        <div className="text-center leading-tight">
          <div className="font-display text-[13px] font-black tracking-wider">{title}</div>
          <div className="cn text-[10px]">{zh}</div>
        </div>
        <div className="space-y-0.5 text-[9px]">
          <div><b>Tanggal / <span className="cn">日期</span>:</b> {date ? fmtDate(date) : "Semua tanggal"}</div>
          <div><b>Jumlah / <span className="cn">数量</span>:</b> <span className="font-mono font-bold">{rows.length}</span> baris · <span className="font-mono font-bold">{totalQty}</span> pcs{isQc && <> · OK <span className="font-mono font-bold">{ok}</span> · Repair <span className="font-mono font-bold">{rows.length - ok}</span></>}</div>
          <div><b>Dicetak oleh / <span className="cn">打印人</span>:</b> {user?.name || "Admin"}</div>
        </div>
      </div>

      <table className="mt-3">
        <thead>
          <tr className="bg-gray-100">
            <TH className="w-8">No</TH>
            <TH>{date ? "Jam" : "Waktu"} / <span className="cn">时间</span></TH>
            <TH>Marking / <span className="cn">构件编号</span></TH>
            <TH>Proyek / <span className="cn">项目</span></TH>
            <TH>Vendor / <span className="cn">供应商</span></TH>
            {!isQc && <TH>Area</TH>}
            <TH>Qty</TH>
            {isQc && <TH>Hasil / <span className="cn">结果</span></TH>}
            {isQc && <TH>Catatan / <span className="cn">备注</span></TH>}
            <TH>Oleh / <span className="cn">操作人</span></TH>
          </tr>
        </thead>
        <tbody>
          {sorted.length === 0 ? (
            <tr><TD className="py-6 text-center" colSpan={10}>Tidak ada data / <span className="cn">暂无数据</span></TD></tr>
          ) : sorted.map((r, i) => (
            <tr key={r.id}>
              <TD className="text-center">{i + 1}</TD>
              <TD className="text-center font-mono">{fmtAt(r.at, !date)}</TD>
              <TD className="font-mono font-bold">{r.code}</TD>
              <TD>{r.projectName}</TD>
              <TD>{r.vendorName}</TD>
              {!isQc && <TD className="text-center font-mono">{r.area}</TD>}
              <TD className="text-center font-mono">{r.qty}</TD>
              {isQc && <TD className={`text-center font-bold ${r.result === "OK" ? "text-emerald-700" : "text-amber-700"}`}>{r.result}</TD>}
              {isQc && <TD>{r.note}</TD>}
              <TD>{r.by}{r.editedBy ? ` (edit: ${r.editedBy})` : ""}</TD>
            </tr>
          ))}
        </tbody>
      </table>
      <div className="mt-4 flex justify-between text-[8px] text-gray-500">
        <span>HONGLU FABRIKASI SISTEM · {isQc ? "QC" : "Material Control"}</span>
        <span>{stamp()}</span>
      </div>
    </div>
  );
}
